import styled from "@emotion/styled";
import { BLUE_LIGHT, OLD_BLUE } from "src/constants/colors";

export default styled.div<{ size: number }>`
  background-color: ${BLUE_LIGHT};
  border-radius: 50%;
  color: ${OLD_BLUE};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: 600;
  font-size: ${({ size }) => size / 2}px;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  text-transform: capitalize;
`;
